import React, { memo } from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tabs from 'components/Tabs';
import tabsValues from '../constants/tabs.values'
import getObjectValue from 'libs/getObjectValue'

const style = theme => ({
	root: {

	}
})

function FormTabs({
	classes,
	id,
	formikProps,
	onChange = () => {},
}) {
	const value = getObjectValue(id, formikProps.values, '')
	
	const handleChange = (value) => {
		formikProps.setFieldValue(id, value)
		onChange(value)
	}

	return (
		<Tabs
			onChange={handleChange}
			tabs={tabsValues}
			value={value}
		/>
	)
}

FormTabs.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(memo(FormTabs, (prevProps, nextProps) => {
	if (prevProps.id !== nextProps.id) return false;
	const id = nextProps.id;
	if (getObjectValue(id, prevProps.formikProps.values) !== getObjectValue(id, nextProps.formikProps.values)) return false;
	return true;
}));